'use strict';

var base = require('lyonscg/product/base');
var slickConfigs = require('actionsports/config/slickConfigs');
var zoomConfigs = require('lyonscg/config/zoomConfigs');
var imagesloaded = require('imagesloaded');
var utils = require('../util/utils');
var qtyInput = require('../components/quantityInput');
var glide = require('org/config/glide');
var glideConfigs = require('site/config/glideConfigs');
var pinchzoom = require('org/pinchzoom/pinch-zoom');

/**
 * @param  {json} product - Product json
 * @param  {json} imgTemp - Product json
 */
function updateMainImages(product, imgTemp) {
    var productID = product.id;
    var $varName = $('.product-detail .set-items, .quick-view-dialog .set-items');
    var $carouselImage;
    var $tempDiv;

    if ($varName.length) {
        $tempDiv = $('div.set-items').find('div[data-pid="' + productID + '"]');
        $carouselImage = $tempDiv.find$('.product-carousel, .primary-images .glideScrollThumb, .primary-images .pdp-slideCarousel');
    } else {
        $carouselImage = $('.primary-images');
    }
    $carouselImage.html(imgTemp);
}

/**
 * @param {Object} response - api response
 */
function updateProp65Content(response) {
    const prop65Container = document.querySelector('.prop-65-msg');
    if ($(prop65Container).length > 0) {
        $(prop65Container).addClass('d-none');
    }
    const prop65Modal = document.querySelector('#prop65Modal');
    if (response.product.prop65Message) {
        $(prop65Modal).find('.prop65-body').empty();
        $(prop65Modal).find('.prop65-body').html(response.product.prop65Message);
        $(prop65Container).removeClass('d-none');
    }
}
/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;

    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length) {
        pid = $($el).closest('.modal-content').find('.product-quickview').data('pid');
    } else if ($('.product-set-detail').length || $('.product-set').length) {
        pid = $($el).closest('.product-detail').find('.product-id').text();
    } else {
        pid = $('.product-detail:not(.bundle-item)').data('pid');
    }

    return pid;
}

/**
 * Disable PDP Zoom
 */
function disableZoom() {
    $('.slide-link').trigger('zoom.destroy');
}

/**
 * Init PDP Zoom
 */
function initZoom() {
    disableZoom();

    var isDesktop = utils.mediaBreakpointUp('lg');
    var $activeSlide = $('.product-carousel .slick-active');
    var $activeBundleSlides = $('.bundle-item .product-carousel .slick-active');
    var $image = $activeSlide.find('.slide-link.zoom-hires');
    var url = $image.attr('href');

    if ($image.length > 0 && url && url !== 'null' && isDesktop) {
        // Start spinner while zoom image loads
        $activeSlide.spinner().start(false);

        var config = {
            url: url,
            callback: function () {
                // Stop spinner when zoom image loaded
                $activeSlide.spinner().stop();
            }
        };
        config = $.extend({}, zoomConfigs, config);

        $image.zoom(config);

        // Enable image zoom on bundled products
        if ($activeBundleSlides.length > 0) {
            $activeBundleSlides.each(function () {
                var $bundleImage = $(this).find('.slide-link.zoom-hires');
                var bundleUrl = $bundleImage.attr('href');

                var bundleConfig = {
                    url: bundleUrl,
                    callback: function () {
                        // Stop spinner when zoom image loaded
                        $(this).spinner().stop();
                    }
                };

                bundleConfig = $.extend({}, zoomConfigs, bundleConfig);

                $(this).zoom(bundleConfig);
            });
        }
    }
}

/**
 * Init the product carousel using a predefined slick configuration
 */
function carouselInit() {
    // var $carousels = $('.page .product-carousel');
    var $vidCarousel = $('.video-carousel');
    var $techCarousel = $('.technology-carousel');
    var $syncCarousel = $('.primary-images .pdp-slideCarousel');
    var $glideSlide = $('.product-carousel');
    var glideLength = glide.getGlideSlideLength;
    var pinchzoomElement = $('.pinch-zoom-init');
    var isDesktop = utils.mediaBreakpointUp('lg');
    // var $glideSlideThumb = $('.primary-images .scrollThumb');

    // if ($syncCarousel.length) {
    //     $('.primary-images .pdp-slideCarousel').not('.slick-initialized').slick(slickConfigs.pdpSlick);
    //     if ($('.modal-dialog').hasClass('quick-view-dialog')) {
    //         $('.quick-view-dialog .scrollThumb').not('.slick-initialized').slick(slickConfigs.QuickViewHorizontalSlick);
    //     } else {
    //         $('.primary-images .scrollThumb').not('.slick-initialized').slick(slickConfigs.pdpHorizontalSlick);
    //     }
    // }

    if ($syncCarousel.length && !($syncCarousel.hasClass('glide--carousel')) && $('.quick-view-dialog .pdp-slideCarousel').length === 0) {
        var glideSyncCarousel = glide.carouselInit('.pdp-slideCarousel', glideConfigs.bellPdp).mount();
        var glideSlideThumb = glide.carouselInit('.scrollThumb', glideConfigs.scrollThumb);
        glide.checkGlideDisableLength(glideSlideThumb);
        glideSlideThumb.mount({ glideLength });

        glide.thumbCarousel(glideSyncCarousel, glideSlideThumb);
        glide.clickGlide('.scrollThumb', glideSyncCarousel, glideSlideThumb);
        if (pinchzoomElement.length > 0 && pinchzoom && !isDesktop) {
            pinchzoomElement.addClass('pinch-zoom');
            pinchzoom.pinchZoomPdp([glideSyncCarousel, glideSlideThumb], false, true);
        }
    } else if ($glideSlide.length && $('.quick-view-dialog .product-carousel').length === 0) {
        var glideSingleCarousel = glide.carouselInit('.product-carousel', glideConfigs.pdp);
        glide.checkGlideDisableLength(glideSingleCarousel);
        glideSingleCarousel.mount({ glideLength });
        if (pinchzoomElement.length > 0 && pinchzoom && !isDesktop) {
            pinchzoomElement.addClass('pinch-zoom');
            pinchzoom.pinchZoomPdp([glideSingleCarousel], false, true);
        }
    }

    // if ($carousels.length) {
    //     // many product tile sliders can exist on a page; loop through them to init individually
    //     $carousels.not('.slick-initialized').each(function (idx) {
    //         imagesloaded($(this)).on('done', function () {
    //             var $carousel = $(this.elements);
    //             var sliderID = 'prodSlider' + idx;
    //             var defaultConfig = slickConfigs.pdp;
    //             // assign unique ID to each slider and target only that slider's controls
    //             $carousel.attr('id', sliderID);
    //             var $sliderControls = $(`#${sliderID}`).next('.product-carousel-arrows');
    //             // hide visible components
    //             $sliderControls.addClass('d-none');

    //             // update slider config to use unique controls and prevent multiple sliders on same page from affecting each other
    //             slickConfigs.pdp.appendDots = $sliderControls.find('.slick-dots-custom');
    //             slickConfigs.pdp.prevArrow = $sliderControls.find('.slick-arrows-custom-prev');
    //             slickConfigs.pdp.nextArrow = $sliderControls.find('.slick-arrows-custom-next');

    //             // destroy and re-init slider after images are loaded
    //             if ($carousel.hasClass('slick-initialized')) {
    //                 $carousel.off('init', initZoom);
    //                 $carousel.off('afterChange', initZoom);
    //                 $carousel.slick('unslick');
    //             }

    //             $carousel.not('.slick-initialized').on('init reInit', function (event, slick) {
    //                     // show slider nav after init
    //                 $sliderControls.removeClass('d-none');
    //                 slickConfigs.reinitPagination(event, slick, 1);
    //                 $carousels.find('.slick-slide').removeAttr('aria-describedby');
    //             }).slick(slickConfigs.pdp);

    //             utils.smartResize(function () {
    //                 slickConfigs.reinitPagination(event, $carousel.slick('getSlick'), 1);
    //             });

    //             // Reverts config to default to prevent chaining
    //             slickConfigs.pdp = defaultConfig;
    //         });
    //     });
    // }
    if ($vidCarousel.length && !glide.checkGlideMounted('.video-carousel')) {
        glide.sameClassMultiCarousel('.video-carousel', glideConfigs.video);
        // $vidCarousel.not('.slick-initialized').on('init reInit', function (event, slick) {
        //     slickConfigs.reinitPagination(event, slick, 1);
        //     $vidCarousel.find('.slick-slide').removeAttr('aria-describedby');
        // }).slick(slickConfigs.video);

        // utils.smartResize(function () {
        //     slickConfigs.reinitPagination(event, $vidCarousel.slick('getSlick'), 1);
        // });
    }
    if ($techCarousel.length && !glide.checkGlideMounted('.technology-carousel')) {
        glide.sameClassMultiCarousel('.technology-carousel', glideConfigs.tech);
        // $techCarousel.not('.slick-initialized').on('init reInit', function (event, slick) {
        //     slickConfigs.reinitPagination(event, slick, 3);
        //     $techCarousel.find('.slick-slide').removeAttr('aria-describedby');
        // }).slick(slickConfigs.tech);

        // utils.smartResize(function () {
        //     slickConfigs.reinitPagination(event, $techCarousel.slick('getSlick'), 3);
        // });
    }
}

/**
 * Init the quickview carousel using a predefined slick configuration
 */
function carouselInitQuickview() {
    var $carouselsQuickview = $('.quick-view-dialog .product-carousel');
    var $carouselSync = $('.quick-view-dialog .pdp-slideCarousel');
    var $glideSlideThumb = $('.primary-images .scrollThumb');
    const glideLength = glide.getGlideSlideLength;

    if ($carouselSync.length && $glideSlideThumb.length && !glide.checkGlideMounted('.pdp-slideCarousel')) {
        const glideSyncCarousel = glide.carouselInit('.pdp-slideCarousel', glideConfigs.plpQuickview);
        glide.checkGlideDisableLength(glideSyncCarousel);
        glideSyncCarousel.mount({ glideLength });
        const glideSlideThumb = glide.carouselInit('.scrollThumb', glideConfigs.quickViewScrollThumb);
        glide.checkGlideDisableLength(glideSlideThumb);
        glideSlideThumb.mount({ glideLength });
        glide.thumbCarousel(glideSyncCarousel, glideSlideThumb);
        glide.clickGlide('.scrollThumb', glideSyncCarousel, glideSlideThumb);
    } else if ($carouselsQuickview.length && !glide.checkGlideMounted('.product-carousel')) {
        var currentCarousel = glide.carouselInit('.product-carousel', glideConfigs.plpQuickview);
        glide.checkGlideDisableLength(currentCarousel);
        currentCarousel.mount({ glideLength });
    }

    // if ($carouselSync.length) {
    //     $('.quick-view-dialog .pdp-slideCarousel').not('.slick-initialized').slick(slickConfigs.pdpSlick);
    //     $('.quick-view-dialog .scrollThumb').not('.slick-initialized').slick(slickConfigs.QuickViewHorizontalSlick);
    // }
    if ($carouselsQuickview.length) {
        // many product tile sliders can exist on a page; loop through them to init individually
        $carouselsQuickview.not('.glide--swipeable').each(function (idx) {
            imagesloaded($(this)).on('done', function () {
                var $carousel = $(this.elements);
                var sliderID = 'qvSlider' + idx;
                var defaultConfig = glideConfigs.pdp;
                // assign unique ID to each slider and target only that slider's controls
                $carousel.attr('id', sliderID);
                var quickViewGlide = glide.carouselInit('.' + $carousel.attr('class'), defaultConfig);
                // destroy and re-init slider after images are loaded
                quickViewGlide.on('mount.before', function () {
                    if ($carousel.hasClass('glide--swipeable')) {
                        $carousel.off('init', initZoom);
                        $carousel.off('afterChange', initZoom);
                        quickViewGlide.destroy();
                    }
                });
                $carousel.not('.glide--swipeable').each(function () {
                    quickViewGlide.mount();
                });
            });
        });
    }
}

/**
 * Init the product carousel using a predefined slick configuration for bonus item
 */
function carouselInitBonus() {
    var $carouselBonus = $('.bonus-product-item');
    if ($carouselBonus.length) {
        $carouselBonus.each(function () {
            var $carouselBonusDiv = $(this).find('.product-carousel');
            if ($carouselBonusDiv.length) {
                imagesloaded($carouselBonusDiv).on('done', function () {
                    $carouselBonusDiv.not('.slick-initialized').slick($.extend(slickConfigs.bonusModal, {
                        appendDots: $carouselBonusDiv.siblings('.product-carousel-arrows').find('.slick-dots-custom'),
                        prevArrow: $carouselBonusDiv.siblings('.product-carousel-arrows').find('.slick-arrows-custom-prev'),
                        nextArrow: $carouselBonusDiv.siblings('.product-carousel-arrows').find('.slick-arrows-custom-next')
                    }));
                });
            }
        });
    }
}

/**
 * Init the product carousel with recommendation in add to cart modal
 */
function addedCartRecommendations() {
    if ($('.addedToCartCarouselAS').length) {
        // many product tile sliders can exist on a page; loop through them to init individually
        // $('.addedToCartCarouselAS').not('.slick-initialized').each(function () {
        //     var $slider = $(this);
        //     var defaultConfig = slickConfigs.productRecommendationTile;
        //     if ($slider.hasClass('recommendation')) {
        //         defaultConfig.slide = '.grid-tile';
        //     }

        //     // each slider target only that slider's controls
        //     var $sliderControls = $slider.next('.product-carousel-arrows');

        //     // update slider config to use unique controls and prevent multiple sliders on same page from affecting each other
        //     slickConfigs.productRecommendationTile.appendDots = $sliderControls.find('.slick-dots-custom');
        //     slickConfigs.productRecommendationTile.prevArrow = $sliderControls.find('.slick-arrows-custom-prev');
        //     slickConfigs.productRecommendationTile.nextArrow = $sliderControls.find('.slick-arrows-custom-next');

        //     $slider.slick(defaultConfig);

        //     utils.smartResize(function () {
        //         slickConfigs.reinitPagination(event, $slider.slick('getSlick'), 4);
        //     });
        // });
        glide.sameClassMultiCarousel('.addedToCartCarouselAS', glideConfigs.productRecommendationTile);
    }

    if ($('.addedToCartCarouselGiro').length) {
        // many product tile sliders can exist on a page; loop through them to init individually
        // $('.addedToCartCarouselGiro').not('.slick-initialized').each(function () {
        //     var $slider = $(this);
        //     var defaultConfig = slickConfigs.productGiroRecommendationTile;
        //     if ($slider.hasClass('recommendation')) {
        //         defaultConfig.slide = '.grid-tile';
        //     }

        //     // each slider target only that slider's controls
        //     var $sliderControls = $slider.next('.product-carousel-arrows');

        //     // update slider config to use unique controls and prevent multiple sliders on same page from affecting each other
        //     slickConfigs.productGiroRecommendationTile.appendDots = $sliderControls.find('.slick-dots-custom');
        //     slickConfigs.productGiroRecommendationTile.prevArrow = $sliderControls.find('.slick-arrows-custom-prev');
        //     slickConfigs.productGiroRecommendationTile.nextArrow = $sliderControls.find('.slick-arrows-custom-next');

        //     $slider.on('init reInit', function (event, slick) {
        //         slickConfigs.reinitPagination(event, slick, 4);
        //     }).slick(defaultConfig);

        //     utils.smartResize(function () {
        //         slickConfigs.reinitPagination(event, $slider.slick('getSlick'), 4);
        //     });
        // });
        glide.sameClassMultiCarousel('.addedToCartCarouselGiro', glideConfigs.productRecommendationTile);
    }
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.choice-of-bonus-product');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $('.modal-body').spinner().start(false);

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="">' + data.labels.selectprods + '</span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $('.modal-body').spinner().start(false);

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
            qtyInput.qvInit();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    return $el && $('.set-items').length
        ? $($el).closest('.set-item').find('.quantity-select')
        : $('.quantity-select');
}

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
    // Update options
    $productContainer.find('.product-options').empty().html(optionsHtml);
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' +
            attrValue.value + '"]');
        var $swatchButton = $attrValue.parent();

        if (attrValue.selected) {
            $attrValue.addClass('selected');
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
        } else {
            $attrValue.removeClass('selected');
            $attrValue.siblings('.selected-assistive-text').empty();
        }

        if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url).data('url', attrValue.url);
        } else {
            $swatchButton.removeAttr('data-url');
        }

        // Disable if not selectable
        $attrValue.removeClass('selectable unselectable');


        if (attr.attributeId === 'size') {
            var currentSize = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' +
            attrValue.value + '"]');
            var sizeBtn = currentSize.parent();
            if (typeof attrValue.display !== 'undefined') {
                if (attrValue.display === true) {
                    sizeBtn.show();
                } else {
                    sizeBtn.hide();
                }
            }
        }

        $attrValue.addClass(attrValue.selectable ? 'selectable' : 'unselectable');
    });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
    var $attr = '[data-attr="' + attr.id + '"]';
    var $defaultOption = $productContainer.find($attr + ' .select-' + attr.id + ' option:first');
    $defaultOption.attr('value', attr.resetUrl);

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer
            .find($attr + ' [data-attr-value="' + attrValue.value + '"]');
        $attrValue.attr('value', attrValue.url)
            .removeAttr('disabled');
        if (!attrValue.selectable) {
            // $attrValue.attr('disabled', true);
        }
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    // For Vista Action Sports, all variation attributes are swatches
    var attrsWithSwatches = ['color', 'size', 'lensTint', 'side'];

    attrs.variationAttributes.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs, attrs);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });
}

/**
 *
 * @param {string} msg - the avialablity message
 * @returns {string} - markup to be rendered
 */
function getAvailabilityMarkup(msg) {
    return '<li><div class="label-1">' + msg + '</div></li>';
}

/**
 * Determine if the current selection is complete, i.e. a selection has been made for all variation attributes.
 * @param {Object} response - ajax response
 * @returns {boolean} - true if the selection is incomplete
 */
function isSelectionIncomplete(response) {
    return response.product.variationAttributes.some(variation => variation.selectedValue === null);
}

/**
 * Determine if the currently selected attribute combo is valid or not, i.e. whether it represents
 * a potentially orderable sku at all.
 * @param {Object} response - ajax response
 * @returns {boolean} - true if the selected combination does not exist or is not orderable
 */
function isSelectionInvalid(response) {
    if (response.product.readyToOrder) return false;
    return response.product.variationAttributes.some(variation => variation.values.some(v => v.selected && !v.selectable));
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var isAvailable = response.product.available;
    var showBackInStockMsg = response.product.productType !== 'master' && response.product.online && response.product.isBackInStockNotificationEligible && !response.product.available;
    var bisPID = response.product.id;

    var availabilityValue = '';
    var availabilityMessages = response.product.availability.messages;
    response.product.availability.incompletecombo = isSelectionIncomplete(response);
    response.product.availability.invalidcombo = isSelectionInvalid(response);
    if (!response.product.readyToOrder) {
        if (response.product.availability.invalidcombo) {
            availabilityValue = getAvailabilityMarkup(response.resources.info_invalidcombination);
        } else if (response.product.availability.incompletecombo) {
            availabilityValue = getAvailabilityMarkup(response.resources.info_selectforstock);
        } else {
            availabilityValue = getAvailabilityMarkup(response.resources.info_selectforstock);
        }
    } else if (isAvailable) {
        availabilityValue += getAvailabilityMarkup(response.resources.available);
    } else if (!isAvailable) {
        availabilityValue += getAvailabilityMarkup(response.resources.unavailable);
        response.product.availability.outofstock = true;
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += getAvailabilityMarkup(message);
        });
    }

    // handle back in stock notification display
    if (showBackInStockMsg) {
        $('.back-in-stock-notification').removeClass('hidden');
        $('.back-in-stock-notification .bisPID').val(bisPID);
    } else {
        $('.back-in-stock-notification').addClass('hidden');
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    var html = '';

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach(function (attribute) {
                html += '<div class="attribute-values">' + attribute.label + ': '
                    + attribute.value + '</div>';
            });
        }
    });

    return html;
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]')
                .data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        }).toArray();

    return JSON.stringify(options);
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
    var isChoiceOfBonusProducts =
        $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    var isVaraint;
    if (response.product.variationAttributes) {
        // updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        updateAttrs(response.product, $productContainer, response.resources);
        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item')
                .attr('data-pid', response.product.id)
                .data('pid', response.product.id);

            $productContainer.parent('.bonus-product-item')
                .attr('data-ready-to-order', response.product.readyToOrder)
                .data('ready-to-order', response.product.readyToOrder);
        }
    }

    // Update primary images
    base.carouselUnslick();
    // $('.primary-images .scrollThumb, .primary-images .pdp-slideCarousel').removeClass('slick-initialized');
    updateMainImages(response.product, response.imgTemp);
    updateProp65Content(response);

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $('.prices .price', $productContainer).length
            ? $('.prices .price', $productContainer)
            : $('.prices .price');
        $priceSelector.replaceWith(response.product.price.html);
    }

    // Update promotions
    $productContainer.find('.promotions').empty().html(response.product.promotionsHtml);

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
            product: response.product, $productContainer: $productContainer, resources: response.resources
        }).trigger('product:statusUpdate', response.product);
    }

    // PFAS
    try {
        var pfasEnable = $productContainer.find('.pfas-pdp-row').data('enablepfas');
        if (pfasEnable) {
            if (response.product.pfasBlockCheckout) {
                $('.pfas-pdp-row').show();
            } else {
                $('.pfas-pdp-row').hide();
            }
        }
    } catch(e) { // eslint-disable-line
    }

    // Update attributes
    $productContainer.find('.main-attributes').empty()
        .html(getAttributesHtml(response.product.attributes));

    var locallyBtn = $productContainer.find('#lcly-button-0');
    if (locallyBtn.length > 0) {
        if (response.product.UPC !== null) {
            lcly_reload_0({ 'upc': response.product.UPC }); // eslint-disable-line
            $('.localretailer').css('visibility', 'visible');
        } else {
            $('.localretailer').css('visibility', 'hidden');
        }
    }
}

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer) {
    if ($productContainer.parent('.bonus-product-item').length <= 0) {
        var optionsHtml = quantities.map(function (quantity) {
            var selected = quantity.selected ? ' selected ' : '';
            return '<option value="' + quantity.value + '"  data-url="' + quantity.url + '"' +
                selected + '>' + quantity.value + '</option>';
        }).join('');
        getQuantitySelector($productContainer).empty().html(optionsHtml);
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer) {
    if (selectedValueUrl) {
        $('body').trigger('product:beforeAttributeSelect',
            { url: selectedValueUrl, container: $productContainer });

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                handleVariantResponse(data, $productContainer);
                updateOptions(data.product.optionsHtml, $productContainer);
                updateQuantities(data.product.quantities, $productContainer);
                $('body').trigger('product:afterAttributeSelect',
                    { data: data, container: $productContainer });
                $.spinner().stop();
                qtyInput.pdpInit();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this).find('.product-id').text(),
            quantity: parseInt($(this).find('label.quantity').data('quantity'), 10)
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    return getQuantitySelector($el).val();
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    var messageType = response.error ? 'alert-danger' : 'alert-success';
    // show add to cart toast
    if (response.newBonusDiscountLineItem
        && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    } else {
        if ($('.add-to-cart-messages').length === 0) {
            $('body').append(
                '<div class="add-to-cart-messages"></div>'
            );
        }
        if ($('#added-to-cart').length > 0) {
            try {
                if ($('.added-to-cart-slot .recommendation-carousel').length) {
                    $('#added-to-cart').modal('show');
                    $('body').on('shown.bs.modal', '#added-to-cart', function () {
                        addedCartRecommendations();
                    });
                } else {
                    $('#added-to-cart').modal('show');
                    $('body').on('shown.bs.modal', '#added-to-cart', function () {
                        // $('.added-to-cart-slot [id^="cq_recomm_slot-"]').text('Item Added to Cart');
                        $('.noCartRecommendations').show();
                    });
                }
            } catch (e) { // eslint-disable-line
            }
        } else {
            $('.add-to-cart-messages').append(
                '<div class="alert ' + messageType + ' add-to-basket-alert text-center new-div" role="alert">'
                + response.message
                + '</div>'
            );
            setTimeout(function () {
                $('.add-to-basket-alert').remove();
            }, 5000);
        }
    }
}

var exportBase = $.extend({}, base, {
    attributeSelect: attributeSelect,
    carouselInit: carouselInit,
    carouselInitQuickview: carouselInitQuickview,
    carouselInitBonus: carouselInitBonus,
    disableZoom: disableZoom,
    addedCartRecommendations: addedCartRecommendations,
    updateMainImages: updateMainImages,
    updateProp65Content: updateProp65Content,
    methods: {
        editBonusProducts: function (data) {
            chooseBonusProducts(data);
        }
    },
    colorAttribute: function () {
        $(document).on('click ', '[data-attr="color"] button', function (e) {
            e.preventDefault();

            // if ($(this).data('disabled') || !($(this).data('url'))) {
            //     return;
            // }
            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }

            attributeSelect($(this).attr('data-url'), $productContainer);
        });
    },
    selectAttribute: function () {
        $(document).on('click ', 'button.noncolor-attribute, button.lensTint-attribute', function (e) {
            e.preventDefault();

            // if ($(this).data('disabled') || !($(this).data('url'))) {
            //     return;
            // }

            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }
            attributeSelect($(this).attr('data-url'), $productContainer);
        });
    },
    availability: function () {
        $(document).on('change', '.quantity-select', function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.modal-content').find('.product-quickview');
            }

            if ($('.bundle-items', $productContainer).length === 0) {
                attributeSelect($(e.currentTarget).find('option:selected').data('url'),
                    $productContainer);
            }
        });
    },

    addToCart: function () {
        $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', function () {
            var addToCartUrl;
            var pid;
            var pidsObj;
            var setPids;

            // Determine if the variant selection process is complete yet. if not, prevent a2c submit
            if ($(this).is('.incomplete')) {
                const unfinishedGroups = $('.attributes').find('.attribute:not(.selected)');
                if (unfinishedGroups.length > 0) {
                    unfinishedGroups.each(function () {
                        $(this).addClass('selection-error');
                    });
                    return;
                }
            }

            $('body').trigger('product:beforeAddToCart', this);

            if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
                setPids = [];

                $('.product-detail.set-item').each(function () {
                    if (!$(this).hasClass('product-set-detail')) {
                        setPids.push({
                            pid: $(this).data('pid'),
                            qty: $(this).find('.quantity-select').val(),
                            options: getOptions($(this))
                        });
                    }
                });
                pidsObj = JSON.stringify(setPids);
            }

            pid = getPidValue($(this));

            var $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
            }
            addToCartUrl = getAddToCartUrl();

            var form = {
                pid: pid,
                pidsObj: pidsObj,
                childProducts: getChildProducts(),
                quantity: getQuantitySelected($(this))
            };

            if (!$('.bundle-item').length) {
                form.options = getOptions($productContainer);
            }

            $(this).trigger('updateAddToCartFormData', form);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: function (data) {
                        handlePostCartAdd(data);
                        $('body').trigger('product:afterAddToCart', data);
                        $.spinner().stop();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    },
    selectBonusProduct: function () {
        $(document).on('click', '.select-bonus-product', function () {
            var $choiceOfBonusProduct = $(this).parents('.choice-of-bonus-product');
            var pid = $(this).data('pid');
            var maxPids = $('.choose-bonus-product-dialog').data('total-qty');
            var submittedQty = parseInt($choiceOfBonusProduct.find('.bonus-quantity-select').val(), 10);
            var totalQty = 0;
            $.each($('#chooseBonusProductModal .selected-bonus-products .selected-pid'), function () {
                totalQty += $(this).data('qty');
            });
            totalQty += submittedQty;
            var optionID = $choiceOfBonusProduct.find('.product-option').data('option-id');
            var valueId = $choiceOfBonusProduct.find('.options-select option:selected').data('valueId');
            if (totalQty <= maxPids) {
                var selectedBonusProductHtml = ''
                + '<div class="row">'
                + '<div class="col">'
                + '<div class="selected-pid" '
                + 'data-pid="' + pid + '"'
                + 'data-qty="' + submittedQty + '"'
                + 'data-optionID="' + (optionID || '') + '"'
                + 'data-option-selected-value="' + (valueId || '') + '"'
                + '>'
                + '<div class="row align-items-center">'
                + '<div class="col bonus-product-name">'
                + $choiceOfBonusProduct.find('.product-name').html()
                + '</div>'
                + '<div class="col-auto"><button class="close"></div></div>'
                + '</div>'
                + '</div>'
                + '</div>'
                + '</div>'
                ;
                $('#chooseBonusProductModal .selected-bonus-products').append(selectedBonusProductHtml);
                $('.pre-cart-products').html(totalQty);
                $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
            } else {
                $('.selected-bonus-products .bonus-summary').addClass('alert-danger');
            }
        });
    },
    getChildProducts: getChildProducts,
    getOptions: getOptions,
    handlePostCartAdd: handlePostCartAdd,
    getPidValue: getPidValue
});

$('.customContact').on('click touchstart', function () {
    sessionStorage.setItem('customContact', 'true');
});

window.addEventListener('LOCALLY_data_update', function () {
    if (!$('#lcly-button-0').hasClass('localretailer')) {
        $('#lcly-button-0').addClass('localretailer text-center');
    }

    $('.lcly-primary-trigger').prepend($('<img>', { id: 'map-pin', src: '/on/demandware.static/Sites-giro-Site/-/default/dw7356f338/images/Map-pin.svg', class: 'locallyImg', alt: 'FIND IT LOCALLY' }));

    var lclyMapPin = {};
    $('.locallyImg').each(function () {
        var txt = $(this).attr('src');
        if (lclyMapPin[txt]) {
            $(this).remove();
        } else {
            lclyMapPin[txt] = true;
        }
    });
}, false);

module.exports = exportBase;
